// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | 生成海报浏览
// +----------------------------------------------------------------------
Vue.prototype.$createdHaibaoLook = function (that, showPrice, title) {
  var length = that.$commaToarr(that.selectedRows, ",").length;
  if (length == 0) {
    that.$msg("请选择至少一条专利", "warning");
    return;
  }
  if (length > 100) {
    that.$msg("最多选择100条数据", "warning");
    return;
  }
  //组合需要复制的数据
  const ids = that.selectedRows.split(",").map(Number); // 转换为数字数组
  const selectedSet = new Set(ids);
  const data = that.list.filter((item) => selectedSet.has(item.id));
  this.$refs.Oshaibao.createdHaibaoLook(data, showPrice, title);
};
